import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const twilioServices = {
    getTwilioMessages,
    getByChildId,
    sendVerifySMS,
    sendWelcomeSMS
};

function getTwilioMessages(phoneNumber) {
    phoneNumber = phoneNumber.replace('+','');
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioMessage/GetByPhoneNumber/'+ phoneNumber, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getByChildId(childId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioMessage/GetByChildId/' + childId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function sendVerifySMS(phoneNumber, messageBody) {
    phoneNumber = phoneNumber.replace('+','');
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    var url = config.apiUrl + '/api/TwilioMessage/SendSMS/'+ phoneNumber+'/'+ encodeURI(messageBody)

    return fetch(url, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function sendWelcomeSMS(phoneNumber, childData) {
    var body={
        "userPhone": phoneNumber,
        "twilioPhone": childData.twilioPhoneNumber,
        "userID": childData.parentId,
        "childID": childData.childrenId,
        "childName": childData.firstName +' '+ childData.lastName
      };
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body:JSON.stringify(body)
    };
    var url = 'https://spinriseapi.azurewebsites.net/Welcome'

    return fetch(url, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


// WEBPACK FOOTER //
// ./src/services/twilio.service.js